import styled from 'styled-components';

export const SalesInventoryContainer = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

export const Header = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const InventoryList = styled.div`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const EmptyState = styled.div`
    padding: 24px;
    text-align: center;
    color: rgba(255, 255, 255, 0.7);
`;